import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, Typography, Paper, CircularProgress } from '@material-ui/core';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import SchoolIcon from '@material-ui/icons/School';
import StarIcon from '@material-ui/icons/Star';
import './Events.css';
import ForumIcon from '@material-ui/icons/Forum';
import axios from 'axios';
import config from '../../../config/config.json';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(5),
        background: '#f7fafd',
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main,
    },
    subHeader: {
        textTransform: "uppercase",
        color: '#fff',
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
        padding: theme.spacing(2),
        background: theme.palette.secondary.dark,
        width: '50%'
    },
    loaderWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(5),
    }
}));

export default function Events({ lang }) {
    const classes = useStyles();

    const [eventos, setEventos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 1);
    }, []);

    useEffect(() => {
        function getEventos() {
            const url = `${config.apiBaseUrl}/eventos`;

            axios.get(url).then(res => {
                setEventos(res.data);
                setIsLoading(false);
            }).catch(err => {
                setIsLoading(false);
            });
        }
        getEventos();
    }, [])


    if (isLoading)
        return (
            <div className="features-bg">
                <div className={classes.loaderWrapper}>
                    <CircularProgress color="secondary" />
                </div>
            </div>
        )
    else
        return (
            <section id="events">
                <div className="features-bg">
                    <Container>
                        <div className="heading">
                            <Typography variant="h4" className="efecto-espejo">Eventos</Typography>
                        </div>
                        <Grid container spacing={3} >
                            <Grid item xs={12} sm={6}>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src="" />
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Paper className={classes.paper} elevation={0}>
                                    <Typography paragraph align="justify" gutterBottom>
                                        Nuestro Centro organiza, promueve y participa en dos importantes eventos científicos cada año, con la precencia de
                                        nuestro Consejo Técnico Asesor y otros especialistas invitados. En cada encuentro está vigente la oportunidad de
                                        intercambiar conocimientos y experiencias, así como de ampliar nuestra red de contactos profesionales. Por favor vea
                                        nuestros eventos.
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid>

                        <Paper className={classes.subHeader}>
                            <Typography variant="h5">Próximos Eventos</Typography>
                        </Paper>

                        <VerticalTimeline className="vertical-timeline-custom-line">

                            {
                                eventos.map(function (evento, index) {
                                    let fechaIni = evento.fecha_inicio.split(' ')[0].split('-').reverse().join('/');
                                    let horaIni = evento.fecha_inicio.split(' ')[1];
                                    return (
                                        <VerticalTimelineElement
                                            className="vertical-timeline-element--work"
                                            contentStyle={{ borderTop: (index % 2 === 0) ? '3px solid #2196f3' : '3px solid #f50057' }}
                                            date={fechaIni + ' ' + horaIni}
                                            iconStyle={{
                                                background: (index % 2 === 0) ? '#2196f3' : '#f50057',
                                                color: '#fff'
                                            }}
                                            icon={(index % 2 === 0) ? <SchoolIcon /> : <ForumIcon />}
                                        >
                                            <Typography variant="h5" align="center" color="textPrimary" className="vertical-timeline-element-title">
                                                {evento.titulo}
                                            </Typography>
                                            <Typography variant="subtitle1" color="textPrimary" className="vertical-timeline-element-subtitle">
                                                {evento.lugar}
                                            </Typography>
                                            <Typography align="justify" color="textSecondary">
                                                {evento.descripcion}
                                            </Typography>
                                        </VerticalTimelineElement>
                                    )
                                })
                            }
                            {/* <VerticalTimelineElement
                                className="vertical-timeline-element--work"
                                contentStyle={{ borderTop: '3px solid #2196f3' }}
                                date={eventos[0].fecha_inicio}
                                iconStyle={{ background: '#2196f3', color: '#fff' }}
                                icon={<SchoolIcon />}
                            >
                                <Typography variant="h5" align="center" color="textPrimary" className="vertical-timeline-element-title">
                                    {eventos[0].titulo}
                                </Typography>
                                <Typography variant="subtitle1" color="textPrimary" className="vertical-timeline-element-subtitle">
                                    {eventos[0].lugar}
                                </Typography>
                                <Typography align="justify" color="textSecondary">
                                    {eventos[0].descripcion}
                                </Typography>
                            </VerticalTimelineElement> */}

                            {/* <VerticalTimelineElement
                                className="vertical-timeline-element--education"
                                date={eventos[1].fecha_inicio}
                                iconStyle={{ background: '#e91e63', color: '#fff' }}
                                icon={<ForumIcon />}
                            >
                                <Typography variant="h5" align="center" color="textPrimary" className="vertical-timeline-element-title">
                                    {eventos[1].titulo}
                                </Typography>
                                <Typography variant="subtitle1" color="textPrimary" className="vertical-timeline-element-subtitle">
                                    {eventos[1].lugar}
                                </Typography>
                                <Typography align="justify" color="textSecondary">
                                    {eventos[1].descripcion}
                                </Typography>
                            </VerticalTimelineElement> */}

                            <VerticalTimelineElement
                                iconStyle={{ background: '#10cc52', color: '#fff' }}
                                icon={<StarIcon />}
                            />
                        </VerticalTimeline>
                    </Container>
                </div>
            </section>
        );
}
